export const FETCH_DATA_REQUEST= "FETCH_DATA_REQUEST";
export const DISPLAY_ERROR_MESSAGE = "DISPLAY_ERROR_MESSAGE";
export const FETCH_DATE_CONFIG = "FETCH_DATE_CONFIG";
export const RESET_MODEL_AND_ERROR_FLAGS = "RESET_MODEL_AND_ERROR_FLAGS";
export const SET_LOADING_FALSE = "SET_LOADING_FALSE";
export const REPORTS_DATA_SUCCESS = "REPORTS_DATA_SUCCESS";

